var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"flex items-center justify-center"},[_vm._t("default"),_c('span',{staticClass:"cursor-pointer"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }